// extracted by mini-css-extract-plugin
module.exports = {"root":"PatternAutocomplete_root__1mRvB","list":"PatternAutocomplete_list__2EGSx"};